const NoMessages = () => {
  return (
    <svg
      className="convEmptyIllustration"
      viewBox="0 0 120 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="10"
        y="18"
        width="65"
        height="44"
        rx="8"
        fill="#e6f7f7"
        stroke="#0f6b6b"
        strokeWidth="1.5"
      />
      <rect
        x="16"
        y="28"
        width="38"
        height="4"
        rx="2"
        fill="#0f6b6b"
        opacity="0.35"
      />
      <rect
        x="16"
        y="36"
        width="50"
        height="3"
        rx="1.5"
        fill="#0f6b6b"
        opacity="0.2"
      />
      <rect
        x="16"
        y="42"
        width="42"
        height="3"
        rx="1.5"
        fill="#0f6b6b"
        opacity="0.2"
      />
      <path
        d="M10 57l8 8v-8H10z"
        fill="#e6f7f7"
        stroke="#0f6b6b"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <rect
        x="45"
        y="38"
        width="65"
        height="44"
        rx="8"
        fill="#e6f0f8"
        stroke="#14508c"
        strokeWidth="1.5"
      />
      <rect
        x="51"
        y="48"
        width="38"
        height="4"
        rx="2"
        fill="#14508c"
        opacity="0.35"
      />
      <rect
        x="51"
        y="56"
        width="50"
        height="3"
        rx="1.5"
        fill="#14508c"
        opacity="0.2"
      />
      <rect
        x="51"
        y="62"
        width="30"
        height="3"
        rx="1.5"
        fill="#14508c"
        opacity="0.2"
      />
      <path
        d="M110 77l-8 8v-8h8z"
        fill="#e6f0f8"
        stroke="#14508c"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default NoMessages;
